<template>
      <fiche-header :ressource="ressource"
                    @back="back"
                    @openAll="openAll"
                    @closeAll="closeAll">
      </fiche-header>
  <div class="fiche">
    <!-- Liste des sections de la fiche -->
    <v-col :class="isCardView ? 'col-7' : 'px-0'" v-if="isDisplayed('ETABLISSEMENT_LIST')">
        <slot name="section-etablissement-list">
          <section-etablissement-list ref="ETABLISSEMENT_LIST"
                                      id="ETABLISSEMENT_LIST"
                                      :extended="isExtended('ETABLISSEMENT_LIST')"
                                      :showButton="true"
                                      :autoSave="true"
                                      :readOnly="readOnly"
                                      :moduleId="moduleId"
                                      :searchText="searchText"
                                      :ressourceHeader="ressource"
                                      :fiche="fiche"
                                      :etablissement=selectedEtablissement
                                      :route="route"
                                      :attribut="attribut"
                                      @extended="setExtended"
                                      @fullscreen="setFullscreen"
                                      @status="updateStatus"
                                      @toggleCardView="toggleCardView"
                                      @updated="etablissementUpdated"
                                      @selectItem = "selectItem">
          </section-etablissement-list>
        </slot>
    </v-col>
  </div>
</template>
<script lang="ts">
import { defineComponent, type PropType } from "vue";
import FicheBase from '@/framework/base/components/FicheBase';
import Route from '@/extend/classes/Route';
import { CiRouter } from '@/framework/base/helpers/NavHelper'
import { Fiches } from '@/generated/classes/AppSchema';
import { Extended } from '@/framework/base/classes/Schema';
import Etablissement from '@/extend/classes/Etablissement';
import FicheHeader from '@/framework/base/components/FicheHeader.vue';
import { GenFiche, RessourceGenFiche } from '@/generated/ressources/generatedRessources';
import SectionEtablissementList from '@/extend/sections/SectionEtablissementListExtend.vue';

export default defineComponent({
  extends: FicheBase,
  components: {
    SectionEtablissementList,
    FicheHeader,
  },

  props: {
    etablissement: {
      type: Object as PropType<Etablissement>,
    },
  },

  created (): void {
    this.addFiches(this.sections);
  },

  data() {
    return {
      moduleId: 0,
      fiche: Fiches.ETABLISSEMENT_LIST,
      sections: [
        'ETABLISSEMENT_LIST',
      ],

    }
  },

  computed: {
    ressource () {
      return RessourceGenFiche(GenFiche.FICHE_ETABLISSEMENT_LIST);
    },

    selectedEtablissement (): Etablissement {
      return this.etablissement
    },
  },
  methods: {
    ficheMounted () {
      this.onShowSectionChanged();
      this.setFocus();
    },

    setFocus (): void {
      if (this.isMounted) {
        let res = false;
        let first = '';
        const route = CiRouter.getRoute();
        const notifSection = route ? route.section : '';
        this.sections.forEach(section => {
          // @ts-expect-error : generated method
          if (this.isDisplayed(section) && this.$refs[section] && this.$refs[section].allReadOnly && this.$refs[section].setFocus) {
            if (notifSection == section) {
              // @ts-expect-error : generated method
              this.$refs[section].setFocus(route);
              res = true;
            } else if (first == '') {
              first = section;
            }
          }
        })
        if (!res && first != '' && this.$refs[first]) {
          // @ts-expect-error : generated method
          this.$refs[first].setFocus(route);
        }
      }
    },

    // eslint-disable-next-line
    etablissementUpdated (etablissement: Etablissement) {
    // To implement
    },

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    isDisplayed (value: string): boolean {
      if ((!this.etablissement || this.etablissement.id < 0) && value == 'ETABLISSEMENT_LIST') {
        this.setExtended(new Extended('ETABLISSEMENT_LIST', this.fiche, true));
      }
      return true;
    }
  }
})
</script>
